import styled from 'styled-components';
import { GridStyled } from '../GridStyled';

export const GridStyledAC = styled(GridStyled)``;
